module.exports = __webpack_public_path__ + "static/media/april.41b33452.png";